const BANK_CONNECT_SERVICE_BASE_URL =
  'https://bank-connect-api.everydollar.com';

const BUDGET_SERVICE_BASE_URL = 'https://api.everydollar.com';

const LOCAL_STORAGE = {
  SKIP_BANK_CONNECT: 'bankConnectTileSkipped',
};

export {
  BANK_CONNECT_SERVICE_BASE_URL,
  BUDGET_SERVICE_BASE_URL,
  LOCAL_STORAGE,
};
